import {AppStartListening} from "../../store";
import {ListenerEffectAPI, PayloadAction, Unsubscribe} from "@reduxjs/toolkit";
import {loadClubs} from "./asyncActions";
import {handleLogOut, LoadUserActionPayload} from "../session/slice";
import {refreshSession} from "../session/asyncActions";
import {handleReset} from "./slice";

const handleUserLoaded = async (_: PayloadAction<LoadUserActionPayload>, listenerApi: ListenerEffectAPI<any, any>) => {
    listenerApi.dispatch(loadClubs())
}

const handleLogout = async (_: any, listenerApi: ListenerEffectAPI<any, any>) => {
    listenerApi.dispatch(handleReset())
}

export function setupClubListeners(startListening: AppStartListening): Unsubscribe {
    const subscriptions = [
        startListening({
            actionCreator: refreshSession.fulfilled,
            effect: handleUserLoaded,
        }),
        startListening({
            actionCreator: handleLogOut,
            effect: handleLogout,
        }),
    ]

    return () => {
        subscriptions.forEach((unsubscribe) => unsubscribe())
    }
}